// extracted by mini-css-extract-plugin
export default {"wrapper":"TextEditor_wrapper__oWfWI","error":"TextEditor_error__yQ23D","toolbar":"TextEditor_toolbar__2WMWM","editor":"TextEditor_editor__R+DDw"};